import {Link} from "react-router-dom";
import React,  {useEffect, useState} from "react";


export const FooterComponent = () => {

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY >= 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return(
        <>
            <footer className={"w-full mx-auto"} style={{maxWidth:"1500px"}}>
                <div className="w-full  bg-gradient-to-t from-gray-50 to-white pt-8 md:pt-32">
                    <div className={"w-11/12 pt-0 pb-10 md:pb-4 mx-auto"}>
                        <div className={"w-99 pb-3 md:pb-0 mx-auto"}>
                            <div className={"block lg:flex justify-between"}>
                                <div className={"w-full md:w-11/12 mx-auto lg:mx-0 lg:w-5/12"}>
                                    <div className={"my-auto flex gap-2 "}>
                                        <div className={"h-10 md:h-12 my-4"}>
                                            <img className={"h-full w-full my-auto object-contain"} src={"/assets/icon/icon-logo.svg"} />
                                        </div>
                                    </div>
                                    <div className={"w-full"}>
                                        <div className={"py-2 text-left"}>
                                            <div className={"text-left text-gray-600"}>
                                                <p className={"text-sm font-light"}>PT Unitek Solusi Indonesia adalah portal untuk setiap perusahaan manufaktur yang mencari mesin sebagai investasi baru untuk perusahaan mereka. Kami menyediakan solusi untuk mesin pengemasan, pemrosesan, inspeksi, pelabelan, mesin coding untuk industri farmasi, kosmetik, makanan dan minuman, serta lainnya. Selain itu, kami juga menyediakan mesin material handling, program, dan desain elektronik untuk kebutuhan industri.</p>
                                            </div>
                                        </div>
                                        <div className={"py-2 text-left"}>
                                            <div className={"text-left flex gap-3 text-gray-600"}>
                                                <p className={"text-sm font-semibold"}> Bizlink Citra Raya Blok P.03 No.106, JL.Pemda Tigaraksa Sukamulya Cikupa Tangerang, Banten 15710, Indonesia </p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className={"w-full my-4"}>
                                        <ul className={"flex gap-4"}>
                                            <li className={""}>
                                                <div className={"w-full"}>
                                                    <a href={"mailto:info@unitek-indonesia.com"}>
                                                        <div className={"h-12 md:h-12 cursor-pointer  w-full p-3 rounded-full  hover:bg-gray-100"}>
                                                            <img className={"h-full w-full object-contain "} src={"/assets/icon/icon-email.svg"} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </li>
                                            <li className={""}>
                                                <div className={"w-full"}>
                                                    <a href={"https://api.whatsapp.com/send?phone=628119001211&text=Hey!%20Are%20you%20selling%20industrial%20goods.%20Can%20you%20tell%20more%20details%20about%20the%20products%20you%20sell%3F"}>
                                                        <div className={"h-12 md:h-12 cursor-pointer w-full  p-3 rounded-full hover:bg-gray-100"}>
                                                            <img className={"h-full w-full object-contain "} src={"/assets/icon/icon-phone.svg"} />
                                                        </div>
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className={"w-full lg:w-6/12"}>
                                    <div className={"w-full lg:mt-14"}>
                                        <div className={"w-full md:text-md text-sm md:w-11/12 mx-auto flex-wrap flex"}>
                                            <div className={"w-4/12 my-3"}>
                                                <div className={"w-full md:w-11/12 mx-auto"}>
                                                    <div className={""}>
                                                        <h4 className={"text-gray-700 font-semibold "}>Home</h4>
                                                    </div>
                                                    <div className={"w-full"}>
                                                        <ul className={"text-left block"}>
                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <li className="my-auto relative">
                                                                        <button
                                                                            onClick={() => {
                                                                                const section = document.getElementById("about-us");
                                                                                if (section) {
                                                                                    section.scrollIntoView({ behavior: "smooth" });
                                                                                }
                                                                            }}
                                                                            className="my-auto text-left mx-auto cursor-pointer"
                                                                        >
                                                                            <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                                Tentang Kami

                                                                            </p>
                                                                        </button>
                                                                    </li>
                                                                </div>
                                                            </li>


                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={"https://www.google.com/maps/place/PT.+Unitek+Solusi+Indonesia/@-6.2352728,106.4960055,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69fbdea6f5b999:0xeba4ec77991aa84d!8m2!3d-6.2352728!4d106.4985804!16s%2Fg%2F11cmsb_fvh?entry=tts&g_ep=EgoyMDI0MTEyNC4xIPu8ASoASAFQAw%3D%3D"}>
                                                                        <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            Alamat Kami
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>

                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <li className="my-auto relative">
                                                                        <button
                                                                            onClick={() => {
                                                                                const section = document.getElementById("client");
                                                                                if (section) {
                                                                                    section.scrollIntoView({ behavior: "smooth" });
                                                                                }
                                                                            }}
                                                                            className="my-auto text-left mx-auto cursor-pointer"
                                                                        >
                                                                            <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                                Klien kami
                                                                            </p>
                                                                        </button>
                                                                    </li>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"w-4/12 my-3"}>
                                                <div className={"w-11/12 mx-auto"}>
                                                    <div className={""}>
                                                        <h4 className={"text-gray-700 font-semibold "}>Products</h4>
                                                    </div>
                                                    <div className={"w-full"}>
                                                        <ul className={"block"}>
                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={"https://checkweigher.co.id/"}>
                                                                        <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            Checkweigher
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>
                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={"https://metaldetector.co.id/"}>
                                                                        <p  className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            Metal Detector
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>
                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={"https://x-ray.id/"}>
                                                                        <p  className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            X-Ray
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"w-4/12 my-3"}>
                                                <div className={"w-11/12 mx-auto"}>
                                                    <div className={"mt-9"}>
                                                        <h4 className={"text-gray-700 font-semibold "}> </h4>
                                                    </div>
                                                    <div className={"w-full"}>
                                                        <ul className={"block"}>
                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={""}>
                                                                        <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            {/*Optical Sorting System*/}
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>

                                                            <li className={"my-3 w-full"}>
                                                                <div className={"w-full"}>
                                                                    <Link to={""}>
                                                                        <p className={"text-gray-600 font-light  hover:text-blue-950 cursor-pointer "}>
                                                                            {/*Vision*/}
                                                                        </p>
                                                                    </Link>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"text-center"}>
                                <p className={"text-blue-950 text-xs md:text-sm font-semibold"}>©2024 PT Unitek Solusi Indonesia. All rights reserved. Development & Theme Design by Unitek</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
